/* eslint-disable func-names, max-len */
$(document).ready(() => {
  const $scrollToSection = $('.js-jump');

  $scrollToSection.on('click tap', function (e) {
    e.preventDefault();

    const target = this.hash;
    const $target = $(target);

    $('html, body').stop().animate({
      scrollTop: $target.offset().top,
    }, 900, 'swing', () => {
      window.location.hash = target;
    });
  });
});
